import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="border-b border-stone-200">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-32 text-center">
        <div className="text-[10px] tracking-[0.28em] uppercase font-bold text-stone-500 mb-4">404</div>
        <h1 className="font-display text-5xl md:text-6xl tracking-tighter font-bold text-stone-900">
          This page is not in the audit.
        </h1>
        <p className="mt-5 text-stone-600 max-w-md mx-auto">
          The page you were looking for doesn't exist, or has been revoked.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-8 inline-flex items-center gap-2 bg-stone-900 text-white px-6 py-3.5 text-sm font-medium rounded-sm hover:bg-stone-800"
        >
          Return home
        </Link>
      </div>
    </section>
  );
}
